import React from 'react';

import Link from 'next/link';
import router from 'next/router';
import { FileIcon, defaultStyles } from 'react-file-icon';

import { GetFileResponse } from 'interfaces/ApiType/apiType';
import AboutIcon from 'public/assets/info.svg';
import OpenFileIcon from 'public/assets/openFile.svg';
import ChatIcon from 'public/assets/Vector.svg';

interface PreviewImgProps {
  fileResponse: GetFileResponse;
  fromManageAccessPermission?: boolean;
}

export default function PreviewImg({
  fileResponse,
  fromManageAccessPermission,
}: PreviewImgProps) {
  const fileExt = fileResponse.data.extension as keyof typeof defaultStyles;

  return (
    <div className="h-full border flex flex-col justify-center px-4 py-8 rounded-lg relative">
      {!fromManageAccessPermission && (
        <div className="absolute left-0 right-0 bottom-0 pb-2 flex justify-evenly">
          <div
            className="px-4 py-2 border border-black rounded-lg flex cursor-pointer font-normal hover:bg-yellow"
            onClick={() => {
              router.push(`/files/${fileResponse.data.uuid}?tab=about`);
            }}
          >
            <img src={AboutIcon.src} alt="About" className="mr-2" />
            <div>About</div>
          </div>
          <div
            className="px-4 py-2 border border-black rounded-lg flex cursor-pointer hover:bg-yellow"
            onClick={() => {
              router.push(`/files/${fileResponse.data.uuid}?tab=chat`);
            }}
          >
            <img src={ChatIcon.src} alt="Chat" className="mr-2" />
            <div>Chat</div>
          </div>
        </div>
      )}
      <Link href={`/files/${fileResponse.data.uuid}`} passHref={false}>
        <a target="_blank">
          <div
            className={`rounded-xl border border-black p-4 h-40 mt-4 overflow-hidden flex items-center relative ${
              fromManageAccessPermission ? 'mb-4' : 'mb-10'
            } `}
          >
            <div className="absolute bottom-1 left-1">
              <img src={OpenFileIcon.src} alt="Open File" className="h-6" />
            </div>
            {fileResponse.data.mimetype.includes('image') ? (
              <img
                src={fileResponse.data.url}
                alt="File Preview"
                className="h-24 m-auto"
              />
            ) : (
              <div className="w-28 m-auto">
                <FileIcon extension={fileExt} {...defaultStyles[fileExt]} />
              </div>
            )}
          </div>
        </a>
      </Link>
    </div>
  );
}
